module.exports = __webpack_public_path__ + "img/DM.4930d813.svg";